import { TDR } from 'tdr-common';

export function distanceBetweenPoints(point1, point2) {
	const { x: x1, y: y1,z: z1 } = point1;
	const { x: x2, y: y2, z: z2 } = point2;

	const dx = x2 - x1;
	const dy = y2 - y1;
	const dz = z2 - z1;

	return Math.sqrt(dx*dx + dy*dy + dz*dz);
}

export function isPointInView(cameraPosition, cameraRotation, point) {

	// Calculate camera direction vector
	const cameraDirection = getDirectionVector(cameraRotation.y, cameraRotation.x);

	// Calculate vector from camera to point
	const directionVector = {
		x: point.x - cameraPosition.x,
		y: point.y - cameraPosition.y,
		z: point.z - cameraPosition.z
	};
	const length = Math.sqrt(directionVector.x * directionVector.x + directionVector.y * directionVector.y + directionVector.z * directionVector.z);
	directionVector.x /= length;
	directionVector.y /= length;
	directionVector.z /= length;
	const cameraLength = Math.sqrt(cameraDirection.x * cameraDirection.x + cameraDirection.y * cameraDirection.y + cameraDirection.z * cameraDirection.z);
	cameraDirection.x /= cameraLength;
	cameraDirection.y /= cameraLength;
	cameraDirection.z /= cameraLength;
	const dotProduct = cameraDirection.x * directionVector.x + cameraDirection.y * directionVector.y + cameraDirection.z * directionVector.z;
	return dotProduct > Math.cos(Math.PI/4);//This threshold is calibrated ish for desktop, will probably have to be a seperate val for mobile
}

export function getDirectionVector(azimuthDegrees, elevationDegrees) {
	// Convert degrees to radians
	const azimuthRad = (azimuthDegrees) * Math.PI / 180;
	const elevationRad = (elevationDegrees) * Math.PI / 180;

	// Compute direction vector components
	const z = -Math.cos(elevationRad) * Math.cos(azimuthRad);
	const x = -Math.cos(elevationRad) * Math.sin(azimuthRad);
	const y = Math.sin(elevationRad);

	// Return the direction vector as an array
	return { x, y, z };
}

export const sortTablesByPos = (tables: TDR.Table[], pos) => {
	return tables.sort((table1, table2) => {
		return distanceBetweenPoints(table1.pos, pos) - distanceBetweenPoints(table2.pos, pos);
	});
};

export const sortTablesByCenter = (tables: TDR.Table[], cameraPosition, cameraRotation) => {
	const cameraDirection = getDirectionVector(cameraRotation.y, cameraRotation.x);

	return tables.sort((table1, table2) => {
		const score1 = calculateCenteringScore(table1.pos, cameraPosition, cameraDirection);
		const score2 = calculateCenteringScore(table2.pos, cameraPosition, cameraDirection);
		return score1 - score2;
	});
};

function calculateCenteringScore(tablePosition, cameraPosition, cameraDirection) {
	const directionToTable = {
		x: tablePosition.x - cameraPosition.x,
		y: tablePosition.y - cameraPosition.y,
		z: tablePosition.z - cameraPosition.z
	};

	const length = Math.sqrt(directionToTable.x * directionToTable.x + directionToTable.y * directionToTable.y + directionToTable.z * directionToTable.z);
	directionToTable.x /= length;
	directionToTable.y /= length;
	directionToTable.z /= length;

	const normalizedCameraDirection = {
		x: cameraDirection.x,
		y: cameraDirection.y,
		z: cameraDirection.z
	};
	const cameraLength = Math.sqrt(normalizedCameraDirection.x * normalizedCameraDirection.x + normalizedCameraDirection.y * normalizedCameraDirection.y + normalizedCameraDirection.z * normalizedCameraDirection.z);
	normalizedCameraDirection.x /= cameraLength;
	normalizedCameraDirection.y /= cameraLength;
	normalizedCameraDirection.z /= cameraLength;

	const dotProduct = normalizedCameraDirection.x * directionToTable.x + normalizedCameraDirection.y * directionToTable.y + normalizedCameraDirection.z * directionToTable.z;

	const angle = Math.acos(Math.max(-1, Math.min(1, dotProduct)));

	const distance = length;

	const centeringWeight = 5.0;
	const distanceWeight = 1.0;

	return (angle * centeringWeight) + (distance * distanceWeight * 0.1);
}